"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
declare global {
  interface Window {
    fbq?: (command: "trackCustom", eventName: string, params?: Record<string, unknown>) => void;
  }
}
const SCROLL_50_EVENT = "Scroll50";
const DWELL_30S_EVENT = "TimeOnPage30s";
const DWELL_MS = 30_000;
const SCROLL_THRESHOLD = 0.5;
// The Meta Pixel base code (window.fbq) is injected async by GTM, so it may
// not exist yet when a trigger fires (e.g. a fast scroll on a fresh load).
// Wait briefly for it instead of dropping the event.
const FBQ_WAIT_MS = 15_000;
const FBQ_POLL_MS = 300;

/**
 * Fires Meta Pixel custom events for engagement signals:
 * - 50% scroll depth
 * - 30 seconds dwell time
 * Each event fires at most once per page view. Requires the Meta Pixel base
 * code (window.fbq) to be loaded (via GTM).
 */
export function MetaConversions() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp, t0);
  return null;
}
function _temp() {
  const timers = [];
  const fireEvent = eventName => {
    const start = Date.now();
    const attempt = () => {
      if (typeof window.fbq === "function") {
        window.fbq("trackCustom", eventName);
        return;
      }
      if (Date.now() - start < FBQ_WAIT_MS) {
        timers.push(window.setTimeout(attempt, FBQ_POLL_MS));
      }
    };
    attempt();
  };
  let scrollFired = false;
  const onScroll = () => {
    if (scrollFired) {
      return;
    }
    const scrollable = document.documentElement.scrollHeight - window.innerHeight;
    if (scrollable <= 0) {
      return;
    }
    if (window.scrollY / scrollable >= SCROLL_THRESHOLD) {
      scrollFired = true;
      window.removeEventListener("scroll", onScroll);
      fireEvent(SCROLL_50_EVENT);
    }
  };
  timers.push(window.setTimeout(() => {
    fireEvent(DWELL_30S_EVENT);
  }, DWELL_MS));
  window.addEventListener("scroll", onScroll, {
    passive: true
  });
  onScroll();
  return () => {
    window.removeEventListener("scroll", onScroll);
    for (const timer of timers) {
      window.clearTimeout(timer);
    }
  };
}